import * as React from "react";
import { forwardRef } from "react";
const SvgHeroiconsOutlinePlusSm = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 12H6M12 6V12V6ZM12 12V18V12ZM12 12H18H12Z", stroke: "#1D5883", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgHeroiconsOutlinePlusSm);
export default ForwardRef;
